<template>
  <div>
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <!-- Add Device button -->
      <div class="btn-space">
        <b-button
          variant="primary"
          @click="openDeviceForm"
        >
          {{ $t('adddevice') }}
        </b-button>
      </div>

      <!-- ค้นหาเลขซ่อม -->
      <div class="search-filters">
        <b-form-group :label="$t('search')">
          <b-form-select
            v-model="searchType"
            :options="searchOptions"
            :placeholder="$t('selectsearchtype')"
            class="input-text"
          />
        </b-form-group>

        <b-form-group
          v-if="searchType"
          :label="getLabelForSearchType(searchType)"
        >
          <b-form-input
            v-model="search[searchType]"
            :placeholder="getPlaceholderForSearchType(searchType)"
            class="input-text"
          />
        </b-form-group>
        <!-- เหลือเเก้บัคหลังบ้าน
        <b-form-group label="วันที่รับ(เรื่มต้น)">
          <b-form-input
            v-model="search.startDate"
            type="date"
          />
        </b-form-group>

        <b-form-group label="วันที่รับ(สิ้นสุด)">
          <b-form-input
            v-model="search.endDate"
            type="date"
          />
        </b-form-group>-->
        <b-button
          style="margin-top: 12px; background-color: #02a63e; color: white; border: none;"
          variant="text-warning"
          @click="searchDeviceList(1)"
        >
          <b-icon
            icon="search"
            aria-hidden="true"
          />
          {{ $t('search') }}
        </b-button>

        <b-button
          style="margin-top: 12px; height: 40px; background-color: gray; color: white; border: none;"
          variant="text-warning"
          @click="clearSearch"
        >
          {{ $t('reset') }}
        </b-button>
      </div>

      <!-- Device Table -->
      <div class="table-wrapper">
        <b-table
          v-if="!isLoading && totalDeviceList > 0"
          :items="devices"
          :fields="fields"
          class="device-table"
        >
          <!-- Define your table cells here -->
          <template #cell(serialNumber)="data">
            {{ data.item.serialNumber || '' }}
          </template>
          <template #cell(deviceName)="data">
            {{ data.item.deviceName || '' }}
          </template>
          <template #cell(model)="data">
            {{ data.item.model || '' }}
          </template>
          <template #cell(category)="data">
            {{ data.item.category ? data.item.category.name : '' }}
          </template>
          <template #cell(subcategory)="data">
            <span>{{ data.item.subcategory ? data.item.subcategory.name : '' }}</span>
          </template>
          <template #cell(user)="data">
            {{ data.item.user ? data.item.user.username : $t('other') }}
          </template>
          <template #cell(purchaseDate)="data">
            {{ data.item.purchaseDate ? new Date(data.item.purchaseDate).toLocaleDateString() : '' }}
          </template>
          <template #cell(department)="data">
            {{ data.item.department ? data.item.department.dept : '' }}
          </template>
          <template #cell(location)="data">
            {{ data.item.location ? data.item.location.locationName : '' }}
          </template>
          <template #cell(price)="data">
            {{ data.item.price !== undefined && data.item.price !== null ? data.item.price.toFixed(2) + ' ฿' : '' }}
          </template>
          <template #cell(status)="data">
            {{ data.item.status || '' }}
          </template>

          <template #cell(actions)="data">
            <b-icon
              icon="info-circle"
              :class="{
                'clickable-icon icon-large': true
              }"
              aria-hidden="true"
              @click="showDetailModal(data.item)"
            />
            <b-icon
              icon="pencil"
              class="clickable-icon icon-large text-warning"
              aria-hidden="true"
              :disabled="loadingDeviceModel"
              @click="editDevice(data.item)"
            />
          </template>
        </b-table>

        <div
          v-if="!isLoading && totalDeviceList === 0"
          class="text-center mt-3"
        >
          <p style="font-size: 28px; font-weight: bold;">
            {{ $t('nondevice') }}
          </p>
        </div>
      </div>
      <div
        v-if="!isLoading && totalDeviceList > 0"
        class="d-flex justify-content-end mt-3"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalDeviceList"
          :per-page="itemsPerPage"
          class="mt-3"
          @change="handlePageChange"
        />
      </div>

      <div
        v-if="isLoadingDetails"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>
      <DeviceModel
        v-if="localShowModal && !isLoadingDetails"
        :local-show-modal="localShowModal"
        :warranty="warrantyData"
        :hardware="deviceHardwareList"
        :fixhistory="fixhistoryList"
        :pmhistory="pmhistoryList"
        :expensefix="expensefixList"
        :devicehistory="devicehistoryList"
        :spare="SpareList"
        :details="selectedDevice || []"
        @close="handleCloseModal"
      />

      <!-- Device Form Modal -->
      <div
        v-if="loadingDeviceModel"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>

      <!-- โมเดลจะไม่แสดงจนกว่าข้อมูลโหลดเสร็จ -->
      <b-modal
        v-model="showForm"
        :title="$t('deviceedit')"
        size="xl"
        hide-footer
        :disabled="loadingDeviceModel"
        @hidden="clearSelectedDevice"
      >
        <DeviceForm
          :device="selectedDevice"
          :categories="categories"
          :users="users"
          :locations="locations"
          :departments="departments"
          :loading="loadingDeviceModel"
          @device-saved="handleDeviceSaved"
          @close="showForm = false"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import apiMst from '@/services/masterDate'
import apiSetting from '@/services/Setting'
import apiAuth from '@/services/auth'
import apiAdmin from '@/services/admin'
import DeviceForm from './DeviceForm.vue'
import DeviceModel from './DeviceModel.vue'

export default {
  components: {
    DeviceForm,
    DeviceModel,
  },
  data() {
    return {
      devices: [],
      categories: [],
      users: [],
      locations: [],
      departments: [],
      roles: [],
      search: {
        serialNumber: '',
        deviceName: '',
        model: '',
        category: '',
        subcategory: '',
        user: '',
        purchaseDate: '',
        department: '',
        location: '',
        startDate: '',
        endDate: '',
        status: '',
      },
      showForm: false,
      isLoading: false,
      isLoadingDetails: false,
      loadingDeviceModel: false,
      localShowModal: false,
      selectedDevice: null,
      warrantyData: [],
      deviceHardwareList: [],
      fixhistoryList: [],
      pmhistoryList: [],
      expensefixList: [],
      devicehistoryList: [],
      SpareList: [],
      searchType: '',
      form: {
        serialNumber: '',
        deviceName: '',
        model: '',
        category: null,
        subcategory: null,
        user: null,
        purchaseDate: '',
        department: null,
        location: null,
        price: 0,
        status: '',
      },
      searchOptions: [
        { value: 'serialNumber', text: this.$t('sndevice') },
        { value: 'deviceName', text: this.$t('devicename') },
        { value: 'model', text: this.$t('model') },
        { value: 'category', text: this.$t('cate') },
        { value: 'subcategory', text: this.$t('subcate') },
        { value: 'user', text: this.$t('user') },
        { value: 'department', text: this.$t('deptname') },
        { value: 'location', text: this.$t('locationname') },
        { value: 'price', text: this.$t('cost') },
        { value: 'status', text: this.$t('status') },
      ],
      totalDeviceList: 0,
      totalPages: 0,
      currentPage: 1,
      itemsPerPage: 5,
    }
  },
  computed: {
    fields() {
      return [
        { key: 'serialNumber', label: this.$t('sndevice'), sortable: true },
        { key: 'deviceName', label: this.$t('devicename'), sortable: true },
        { key: 'model', label: this.$t('model'), sortable: true },
        { key: 'category', label: this.$t('cate'), sortable: true },
        { key: 'subcategory', label: this.$t('subcate'), sortable: true },
        { key: 'user', label: this.$t('user'), sortable: true },
        { key: 'purchaseDate', label: this.$t('getdevice'), sortable: true },
        { key: 'department', label: this.$t('deptname'), sortable: true },
        { key: 'location', label: this.$t('locationname'), sortable: true },
        { key: 'price', label: this.$t('cost'), sortable: true },
        { key: 'status', label: this.$t('status'), sortable: true },
        { key: 'actions', label: this.$t('management') },
      ]
    },
  },
  created() {
    this.fetchDevices()
    this.fetchCategories()
    this.fetchUsers()
    this.fetchLocations()
    this.fetchDepartments()
  },
  methods: {
    async handlePageChange(page) {
      this.currentPage = page // ตั้งค่า currentPage ใหม่
      await this.searchDeviceList(this.currentPage)
      this.localShowModal = false
    },

    async searchDeviceList(page = 1) {
      this.isLoading = true
      try {
        // ตรวจสอบว่าฟิลด์ค้นหาว่าง
        if (!this.search.serialNumber && !this.search.price && !this.search.location && !this.search.department && !this.search.user && !this.search.subcategory && !this.search.category && !this.search.model && !this.search.deviceName && !this.search.status && !this.search.startDate && !this.search.endDate) {
          await this.fetchDevices(page)
          return
        }
        this.currentPage = page
        const params = {
          serialNumber: this.search.serialNumber || null,
          deviceName: this.search.deviceName || null,
          model: this.search.model || null,
          category: this.search.category || null,
          subcategory: this.search.subcategory || null,
          user: this.search.user || null,
          startDate: this.search.startDate || null,
          endDate: this.search.endDate || null,
          department: this.search.department || null,
          location: this.search.location || null,
          status: this.search.status || null,
          price: this.search.price || null,
          page: page - 1, // ตั้งค่าหน้า (ลดค่าหนึ่งเพราะ API ใช้หน้า 0-based index)
          size: this.itemsPerPage, // ขนาดของข้อมูลต่อหน้า
        }

        const response = await apiMst.get('/deviceList/search', { params })

        // ตรวจสอบว่า response มีข้อมูลที่ต้องการ
        if (response && response.data) {
          this.devices = response.data.content || [] // อัปเดต devices ด้วยข้อมูลที่ได้รับ
          this.totalDeviceList = response.data.totalElements // จำนวนข้อมูลทั้งหมด
          this.totalPages = response.data.totalPages

          // หากค้นหาแล้วไม่มีข้อมูล
          this.errorMessage = this.totalDeviceList === 0 ? 'ไม่พบข้อมูลที่ค้นหา' : ''
        } else {
          console.error('Invalid response structure:', response)
          this.errorMessage = 'เกิดข้อผิดพลาดในการดึงข้อมูล'
        }
      } catch (error) {
        console.error('Error fetching devices:', error)
        this.devices = []
        this.totalDeviceList = 0
        this.totalPages = 0
        this.errorMessage = 'เกิดข้อผิดพลาดในการดึงข้อมูล'
      } finally {
        this.isLoading = false
        this.localShowModal = false
      }
    },

    async showDetailModal(device) {
      this.localShowModal = true
      this.showForm = false
      this.selectedDevice = { ...device }

      this.isLoadingDetails = true
      try {
        await Promise.all([
          this.fetchfixhistory(),
          this.fetchDeviceHistory(),
          this.fetchDeviceHardwares(),
          this.fetchWarranties(),
          this.fetchSpareList(),
          this.fetchexpense(),
          this.fetchpmhistory(),
        ])
      } catch (error) {
        console.warn('Error loading data')
      } finally {
        this.isLoadingDetails = false
      }
    },

    getLabelForSearchType(type) {
      const labels = {
        serialNumber: this.$t('searchsndevice'),
        deviceName: this.$t('searchnamedevice'),
        model: this.$t('searchmodel'),
        category: this.$t('searchcate'),
        subcategory: this.$t('searchsubcate'),
        user: this.$t('searchuser'),
        department: this.$t('searchdepartment'),
        location: this.$t('searchlocation'),
        price: this.$t('searchcost'),
        status: this.$t('searchstatus'),
      }

      return labels[type] || ''
    },

    getPlaceholderForSearchType(type) {
      const placeholders = {
        serialNumber: this.$t('sndevice'),
        deviceName: this.$t('devicename'),
        model: this.$t('model'),
        category: this.$t('cate'),
        subcategory: this.$t('subcate'),
        user: this.$t('user'),
        department: this.$t('deptname'),
        location: this.$t('locationname'),
        price: this.$t('cost'),
        status: this.$t('status'),
      }

      return placeholders[type] || ''
    },

    async fetchWarranties() {
      if (!this.selectedDevice) return

      try {
        const response = await apiMst.get(`/warrantyByDeviceId/${this.selectedDevice.id}`)
        if (response.status === 200) {
          if (Array.isArray(response.data)) {
            this.warrantyData = response.data // ถ้าเป็น Array
          } else if (typeof response.data === 'object') {
            this.warrantyData = [response.data] // แปลง Object เป็น Array
          } else {
            this.warrantyData = [] // ถ้าไม่ใช่ทั้งสอง
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.warn('No warranties found for this device.')
          this.warrantyData = [] // กำหนดเป็น Array ว่าง
        } else {
          console.warn('Error fetching warranties')
        }
      }
    },

    async fetchDeviceHardwares() {
      try {
        const response = await apiMst.get(`/devicehardwareByDeviceId/${this.selectedDevice.id}`)
        this.deviceHardwareList = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.warn('Error fetching device hardwares')
        this.deviceHardwareList = []
      }
    },

    async fetchfixhistory() {
      try {
        const response = await apiAdmin.get(`/fixgetdevice/${this.selectedDevice.id}`)
        this.fixhistoryList = Array.isArray(response.data)
          ? response.data.sort((a, b) => (b.order - a.order)) // เรียงจากมากไปน้อย
          : []
      } catch (error) {
        console.warn('Error fetching fix history')
        this.fixhistoryList = []
      }
    },

    async fetchpmhistory() {
      try {
        const response = await apiAuth.get(`/calendar/getdeviceCalendar?deviceId=${this.selectedDevice.id}`)
        this.pmhistoryList = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.warn('Error fetching pm history')
        this.pmhistoryList = []
      }
    },

    async fetchexpense() {
      try {
        const response = await apiAdmin.get(`/expensefixList/device/${this.selectedDevice.id}`)
        this.expensefixList = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.warn('Error fetching fix history')
        this.expensefixList = []
      }
    },

    async fetchSpareList() {
      try {
        const response = await apiAdmin.get(`/sparelistByDevice/${this.selectedDevice.id}`)
        const spareData = Array.isArray(response.data) ? response.data : []
        this.SpareList = spareData.map((spare, index) => ({
          id: spare.id,
          orderlist: index + 1,
          list: spare.spList || '',
          purchase: spare.spPurchase || '',
          quantity: spare.spQuantity || '',
          cost: spare.spCost || 0,
          source: spare.spSource || '',
          detail: spare.spDetail || '',
        }))
      } catch (error) {
        console.warn('Error fetching spare list')
        this.SpareList = []
      }
    },

    async fetchDeviceHistory() {
      try {
        const response = await apiAdmin.get(`/deviceUseHistoryGet/${this.selectedDevice.id}`)
        this.devicehistoryList = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        console.warn('Error fetching fix history')
        this.devicehistoryList = []
      }
    },

    async fetchDevices() {
      this.isLoading = true
      try {
        const params = {
          page: this.currentPage - 1, // API uses 0-based indexing
          size: this.itemsPerPage,
        }

        const response = await apiMst.get('/deviceList', { params })
        this.devices = response.data.content || []

        this.totalDeviceList = response.data.totalElements
        this.totalPages = response.data.totalPages
      } catch (error) {
        console.error('Error fetching devices:', error)
      } finally {
        this.isLoading = false
      }
    },
    async fetchCategories() {
      try {
        const response = await apiMst.get('/device')
        this.categories = response.data || []
      } catch (error) {
        console.error('Error fetching categories:', error)
      }
    },
    async fetchUsers() {
      try {
        const response = await apiAuth.get('/auth/showdata')
        this.users = response.data || []
      } catch (error) {
        console.error('Error fetching users:', error)
      } finally {
        this.loadingDeviceModel = false
      }
    },
    async fetchLocations() {
      try {
        const response = await apiMst.get('/location')
        this.locations = response.data || []
      } catch (error) {
        console.error('Error fetching locations:', error)
      }
    },
    async fetchDepartments() {
      try {
        const response = await apiSetting.get('/dept')
        this.departments = response.data || []
      } catch (error) {
        console.error('Error fetching departments:', error)
      }
    },
    async editDevice(device) {
      // ตรวจสอบว่าโมเดลกำลังโหลดข้อมูลอยู่หรือไม่
      if (this.loadingDeviceModel) {
        console.log('ยังไม่โหลดเสร็จ')
        return
      }

      this.localShowModal = false
      this.showForm = false

      // ถ้ายังไม่โหลดข้อมูล
      if (this.users.length === 0) {
        this.loadingDeviceModel = true
        await this.fetchUsers()

        this.selectedDevice = { ...device }
        this.showForm = true
      } else {
        this.selectedDevice = { ...device }
        this.showForm = true
      }
    },
    async openDeviceForm() {
      if (this.loadingDeviceModel) {
        console.log('ยังไม่โหลดเสร็จ')
        return
      }

      // ถ้ายังไม่มีข้อมูลผู้ใช้
      if (this.users.length === 0) {
        // เริ่มโหลดข้อมูล
        this.loadingDeviceModel = true
        await this.fetchUsers()

        // เมื่อโหลดเสร็จ เปิดฟอร์ม
        this.selectedDevice = {
          serialNumber: '',
          deviceName: '',
          model: '',
          category: { id: null, name: 'Select Category' },
          subcategory: { id: null, name: 'Select Subcategory' },
          user: { id: null, username: 'Select User' },
          purchaseDate: '',
          department: { id: null, dept: 'Select Department' },
          location: { id: null, locationName: 'Select Location' },
          price: 0,
          purchaseStatus: '',
          disDate: null,
        }
        this.showForm = true
      } else {
        this.selectedDevice = {
          serialNumber: '',
          deviceName: '',
          model: '',
          category: { id: null, name: 'Select Category' },
          subcategory: { id: null, name: 'Select Subcategory' },
          user: { id: null, username: 'Select User' },
          purchaseDate: '',
          department: { id: null, dept: 'Select Department' },
          location: { id: null, locationName: 'Select Location' },
          price: 0,
          purchaseStatus: '',
          disDate: null,
        }
        this.showForm = true
      }
      this.localShowModal = false
    },
    clearFilters() {
      this.search = {
        serialNumber: '',
        deviceName: '',
      }
    },
    async handleDeviceSaved() {
      await this.fetchDevices()
      this.showForm = false
      this.clearSelectedDevice()
    },
    clearSelectedDevice() {
      this.selectedDevice = null
    },
    handleCloseModal() {
      this.localShowModal = false
      this.selectedDevice = null
    },

    clearSearch() {
    // รีเซ็ตค่าการค้นหา
      this.searchType = null
      this.search = {
        serialNumber: '',
        deviceName: '',
        model: '',
        category: '',
        subcategory: '',
        user: '',
        startDate: '',
        endDate: '',
        department: '',
        location: '',
        price: '',
        status: '',
      }
    },
  },
}
</script>
<style scoped>
.btn-space {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}
.device-table {
  font-size: small;
}
.device-table td,
.device-table th {
  font-size: small;
}

.clickable-icon {
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.search-filters {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.loading-container {
  text-align: center;
  color: #fff;
}

.loading-text {
  margin-top: 10px;
  font-size: 16px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* สีพื้นหลังขุ่น */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* ทำให้ overlay อยู่เหนือโมเดล */
}

/* ปรับ spinner ให้อยู่กลางจอ */
.spinner {
  color: #fff;
  font-size: 30px;
}

.device-table thead {
    display: none; /* ซ่อนหัวตาราง */
  }

.table-wrapper {
  overflow-x: auto;
  width: 100%;
  white-space: nowrap;
}

.device-table{
  width: 100%;
  border-collapse: collapse;
}

@media (max-width: 768px) {
  .device-table {
    display: block;
    overflow-x: auto;
  }
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}

</style>
